import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { forgotPassword } from '../services/api';
import { Button } from "../components/ui/Button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../components/ui/Card";
import { Input } from "../components/ui/Input";
import { Label } from "../components/ui/Label";

function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setIsLoading(true);

        try {
            await forgotPassword(email);
            setMessage('Se um email válido foi fornecido, um link de redefinição de senha foi enviado para o seu email.');
            toast.success('Verifique seu email para o link de redefinição de senha.');
            setEmail('');
        } catch (err) {
            console.error('Erro ao solicitar reposição de senha:', err);
            setError(err.message || 'Ocorreu um erro ao tentar solicitar a reposição de senha.');
            toast.error(err.message || 'Erro ao solicitar reposição de senha.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-background">
            <Card className="w-full max-w-sm">
                <CardHeader className="text-center">
                    <img src="/ucm-logo.png" alt="Gestão de Presenças Logo" className="w-24 h-auto mx-auto mb-4" />
                    <p className="text-sm text-muted-foreground mb-2">Universidade Católica de Moçambique</p>
                    <CardTitle className="text-2xl">Gestão de Presenças</CardTitle>
                </CardHeader>
                <form onSubmit={handleSubmit}>
                    <CardContent className="grid gap-4">
                        {message && <p className="text-sm font-medium text-green-600">{message}</p>}
                        {error && <p className="text-sm font-medium text-destructive">{error}</p>}
                        <div className="grid gap-2">
                            <Label htmlFor="email">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                placeholder="m@exemplo.com"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                    </CardContent>
                    <CardFooter className="flex flex-col">
                        <Button className="w-full" type="submit" disabled={isLoading}>
                            {isLoading ? 'A enviar...' : 'Enviar Link de Redefinição'}
                        </Button>
                        <p className="mt-4 text-xs text-center text-muted-foreground">
                            <Link to="/login" className="underline transition-colors hover:text-primary"> {/* Adicionado transições */}
                                Voltar ao Login
                            </Link>
                        </p>
                    </CardFooter>
                </form>
            </Card>
        </div>
    );
}

export default ForgotPasswordPage;